import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Survey } from './models/survey.model';

export interface SurveyState extends EntityState<Survey> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'survey', idKey: 'SurveyId', cache: { ttl: 30000 } })
export class SurveyStore extends EntityStore<SurveyState> {

  constructor() {
    super();
  }

}

